/**
 * 表单控件的基础方法，供控件继承
 * wangz
 * 2018.3.12
 */

"use strict"
import { sgiFormCtlCheck } from "./sgiFormCtlValidator"
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import { ObjFactory } from "rt-sd-common/sgiFactory/ObjFactory";
import { testReactVsn, getFunctionByKey } from "./sgiBaseComp/SgiCommon";


var sgiFormCtlBaseFun = {

    /**
     * 初始化state属性
     */
    initState: function () {
        //初始化state
        this.state = {
            validRules: {},
            validState: true,
            required: false,
            loading: false,
            isLabel: false,
            formItemProps: {
                style: { 'margin-bottom': "1px", 'margin-top': "1px" },
                hasFeedback: false,
                help: undefined,
                validateStatus: 'success',
                // colon: false //不显示：
            }, //存放formItem属性
            inputprops: {
                style: { width: "100%" },
                // value: undefined,  //文本框显示值 //2018.04.27-yly,有value会导致默认值无法赋值
                disabled: false, //是否可用
            },//存放input属性
            functions: {}, //存放事件函数
            _formProps: {}, //存放form属性
            noFI: this.props.noFI, //去除FormItem
        };
    },

    /**
    * 设置value值
    * 刷新控件时候，调用的方法
    */
    setValue: function (value) {
        //更新state
        if (value === this.state.inputprops.value) {
            return;
        }
        this.state.inputprops.value = value;

        //调用自定义change事件  2018.6.11追加的  //不能要了，出bug了，hanzb 2018-6-14
        // let onChange = this.state.functions.onChange;
        // if (onChange) {
        //     sgiLogger.eventin('修改');
        //     onChange(this, this.props.objFct, value, this.props.objFct.get(this.props.bdInst));
        // }

        //页面校验 刷新不校验
        // this.validate(value);
        this.setState({ loading: false });
    },

    /**
    * 获取value值
    */
    getValue: function () {
        return this.state.inputprops.value;
    },

    /**
     * 设置是否禁用
     */
    setDisabled: function (value) {
        this.state.inputprops.disabled = value;
        this.setState(this.state.inputprops);
    },

    /**
     * 设置form禁用标识
     * @param {boolean} formDisabled form禁用标识
     */
    setFormDisabled: function (formDisabled) {
        this.state.inputprops.formDisabled = formDisabled;
        this.setState(this.state.inputprops);
    },

    /**
    * 设置是否隐藏
    */
    setHidden: function (value) {
        // this.state.inputprops.hidden = value; //2018.04.25-yly,修改弹窗无法隐藏问题
        // this.setState(this.state.inputprops);
        if (value) {
            this.state.formItemProps.style.display = "none"
        } else {
            this.state.formItemProps.style.display = undefined;
        }
        if (testReactVsn(this, 16)) {
            // react16需要更新引用
            this.state.formItemProps.style = { ...this.state.formItemProps.style };
        }
        this.setState(this.state.formItemProps);
    },

    /**
     * 设置是否必填
     * @param {boolean} required 是否必填
     */
    setRequired: function (required) {
        required = !!required;
        this.state.required = required;
        this.setState({});
    },
    // /**
    // * 设置是否只读
    // */
    // setReadonly: function (value) {
    //     this.state.inputprops.style.readonly = value;
    //     this.setState(this.state.inputprops);
    // },
    /**
     * 页面修改时，刷新工厂绑定的值
     */
    ctlRefresh: function (attname, bdInst, objFct, value) {

        //对象工厂的值刷新
        this.setBindValue(attname, bdInst, objFct, value);
        // if (bdInst && attname) {
        //     //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
        //     //通过type区分，type==tb时候为表格控件，其他时候为普通控件
        //     let bdInstData;
        //     if (this.props.type === 'tb') {
        //         const bdInstKeyList = bdInst.split('`');
        //         const bdInstList = objFct.get(bdInstKeyList[0]);
        //         if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
        //             bdInstData = bdInstList[parseInt(bdInstKeyList[1])];
        //         }
        //     } else {
        //         bdInstData = objFct.get(bdInst);
        //     }
        //     bdInstData[attname] = value;
        // }

        //更新state
        this.state.inputprops.value = value;

        //页面校验
        this.validate(value);
    },

    /**
     * 仅更新工厂绑定值
     * @param {string} attname 属性名
     * @param {string} bdInst 绑定实例名
     * @param {ObjFactory} objFct 对象工厂
     * @param {object} value 值
     */
    setBindValue: function (attname, bdInst, objFct, value) {
        if (bdInst && attname) {
            let bdInstData;
            //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
            //通过type区分，type==tb时候为表格控件，其他时候为普通控件
            if (typeof bdInst === "string") {
                //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
                //通过type区分，type==tb时候为表格控件，其他时候为普通控件
                if (this.props.type === 'tb') {
                    const bdInstKeyList = bdInst.split('`');
                    const bdInstList = objFct.get(bdInstKeyList[0]);
                    if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
                        bdInstData = bdInstList[parseInt(bdInstKeyList[1])];
                    }
                } else {
                    bdInstData = objFct.get(bdInst);
                }
            } else {
                bdInstData = bdInst;
            }
            if (bdInstData) {
                if (RegExp(/[.|\[|\]]+/).test(attname)) {
                    // 带层级赋值，catch避免中断
                    try {
                        eval(`(bdInstData.${attname} = value)`);
                    } catch (error) {
                        sgiLogger.error(`修改绑定对象时，属性名解析出错，当前属性名[${attname}]`);
                        sgiLogger.eventErr(error);
                    }
                } else {
                    bdInstData[attname] = value;
                }
            }
            // if (bdInstData) bdInstData[attname] = value;
        }
    },

    // 检查数据合法性
    validate: function (value) {
        if (!value) {
            value = this.state.inputprops.value;
        }
        if (this.state.formItemProps.style.display == "none") {
            this.setSuccess();
            return false;
        }
        var validRules = this.state.validRules;
        if (validRules.length === 0) {
            this.setSuccess();
            return false;
        }

        //var flag = true;
        var msg = sgiFormCtlCheck(validRules, value, { module: this, objFct: this.props.objFct });
        if (Object.prototype.toString.call(msg) === "[object Object]") {
            this.setValidate(msg.help, msg.validateStatus, msg.hasFeedback);
        } else if (msg) {
            this.setError(msg);
        } else {
            this.setSuccess();
        }
        return msg;
    },
    setError: function (msg) {
        this.state.formItemProps.hasFeedback = true;
        this.state.formItemProps.help = msg;
        this.state.formItemProps.validateStatus = 'error';
        this.setState(this.state.formItemProps);
    },
    setSuccess: function () {
        this.state.formItemProps.hasFeedback = this.state.showCheck || false;
        this.state.formItemProps.help = undefined;
        this.state.formItemProps.validateStatus = 'success';
        this.setState(this.state.formItemProps);
    },
    // 设置组件校验(对外接口)
    setValidate: function (message, status, hasFeedback) {
        this.state.formItemProps.help = message;
        this.state.formItemProps.validateStatus = status;
        this.state.formItemProps.hasFeedback = !!hasFeedback;
        this.setState({});
    },
    refresh: function () {
        this.loaded = false;
        this.setState({ loading: false });
    },
    getIsLabel: function () {
        // isLabel
        const isLabel = this.state.isLabel || this.state.formIsLabel;

        // 标签和非标签特殊处理
        let { formItemProps, validRules } = this.state;
        const { moduleDesc } = this.props;
        if (isLabel) {
            formItemProps.required = false;
            validRules.required = false;
        } else {
            let alwBlk = moduleDesc.alwBlk; //是否允许为空
            formItemProps.required = !alwBlk;
            validRules.required = !alwBlk;
        }

        // 返回
        return isLabel;
    },
    getReviseProps: function () {
        const { inputprops, formItemProps, _formProps } = this.state;
        let isLabel = this.getIsLabel();
        let reviseProps = {
            _inputProps: {
                isLabel,
                disabled: inputprops.disabled || inputprops.formDisabled,
                title: inputprops.value,
                className: inputprops.nowrap ? "sgiFormItemSpan" : undefined,
            },
            _formItemProps: {
                colon: isLabel || _formProps.colon, //冒号
            }
        };
        return reviseProps;
    },

    // 初步设计为渲染前的通用处理，例如自定义样式等，以后也许可以放入渲染前/更新前事件中，或重写render方法
    renderBeforeReturn: function () {
        const { parentModule, moduleDesc, objFct, type } = this.props;
        let { formItemProps, inputprops, required } = this.state;

        // 自定义样式处理
        // const getCstmStyle = this.state.cstmStyle;
        const getCstmStyle = getFunctionByKey(this, "cstmStyle");;
        let cstmStyle = {};
        if (getCstmStyle) {
            try {
                cstmStyle = getCstmStyle(this, objFct) || {};
            } catch (error) {
                tool.sgiLogger.log(error);
            }
        }
        for (const key in cstmStyle) {
            if (key.toLowerCase() === "formItemStyle".toLowerCase() || key.toLowerCase() === "formItemProps".toLowerCase()) {
                Object.assign(formItemProps.style, cstmStyle[key] || {});//formTtem样式
            } else if (key.toLowerCase() === "inputStyle".toLowerCase() || key.toLowerCase() === "inputProps".toLowerCase()) {
                Object.assign(inputprops.style, cstmStyle[key] || {});//input样式
            } else {
                this.state[key] = cstmStyle[key];//其他样式，富文本等的其他样式
            }
        }

        // 必填属性处理
        formItemProps.required = required;
        this.state.validRules.required = required;

    },
}
export { sgiFormCtlBaseFun }



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/sgiFormCtlBaseFun.js